let lastQ = '';
let lastDelayQuery = Date.now() + 3600;
let delayedTimeOut = null;

/**
 * @param flag
 */
function disableBody(flag) {
  if (flag) {
    $('body').css('overflow', 'hidden').css('height', $(window).height());
  } else {
    $('body').css('overflow', 'scroll').css('height', 'auto');
  }
}

/**
 * @param delta
 * @param callback
 * @param args
 * @param callback_args
 */
function delayed(delta, callback, args) {
  const now = Date.now();
  if (delayedTimeOut) window.clearTimeout(delayedTimeOut);
  if (now - lastDelayQuery > delta) {
    callback(args);
  } else {
    delayedTimeOut = window.setTimeout(() => {
      delayed(delta, callback, args, true);
    }, delta);
  }
  lastDelayQuery = now;
}

/**
 *
 */
function showSearchResults() {
  const q = $('#searchQuery').val();
  window.location.href = `/search/?q=${q}`;
}

/**
 *
 */
function hideSearchResults() {
  $('#searchResultsWindow').remove();
  $('#displaySearchResult').hide();
}

/**
 * @param e
 */
function searchResultsHandler(e) {
  if (e.keyCode === 13) {
    showSearchResults();
    return;
  }

  if ($(window).width() < 768) return;

  if (e.keyCode === 27) {
    $('#searchPanelClose').trigger('click');
    return;
  }

  const q = $.trim($('#searchQuery').val());

  if (q === lastQ) return;

  if (q === '') {
    hideSearchResults();
    return;
  }

  const iframe = $('<iframe src="" id="emptyIframeSearch">');
  iframe.attr('src', `/search-results.html?q=${q}`);

  iframe.on('load', () => {
    if ($('#searchResultsWindow')[0]) hideSearchResults();
    iframe.attr('id', 'searchResultsWindow');
    const cssLink = document.createElement('link');
    cssLink.href = '/_core/css/search.css';
    cssLink.rel = 'stylesheet';
    cssLink.type = 'text/css';
    $('#searchResultsWindow')[0].contentWindow.document.head.appendChild(cssLink);
    $('#displaySearchResult').show();
    $('#displaySearchResult').height($(window).height() - 100);
    const arr = $('#searchResultsWindow')[0].contentWindow.document
      .getElementsByClassName('gsc-cursor-page');
    if (arr.length === 1) {
      $.each(arr, /** @this {*} */function iterator() { $(this).hide(); });
    }
    const searchRes = $('#searchResultsWindow')[0].contentWindow.document
      .getElementsByClassName('gsc-result-info');
    if (searchRes[0] && searchRes[0].innerHTML) {
      searchRes[0].innerHTML = (searchRes[0].innerHTML).toString().replace(/\(.*\)/, '');
      searchRes[0].style.display = 'block';
    }
  });
  $('#displaySearchResult').append(iframe);
  lastQ = q;
}

$('#searchQuery').keyup(e => {
  delayed(250, searchResultsHandler, e);
});

// some magic
$(document).on('shown.bs.dropdown', event => {
  const dropdown = $(event.target);
  // Set aria-expanded to true
  dropdown.find('.dropdown-menu').attr('aria-expanded', true);

  // Set focus on the first link in the dropdown
  if (dropdown[0].id === 'dd_search') {
    if ($(window).width() > 768) {
      $('#searchFadeDiv').show();
      disableBody(true);
      setTimeout(() => {
        $('#searchQuery').focus();
      }, 10);
    }
  }
});

// some magic
$(document).on('hide.bs.dropdown', event => {
  const dropdown = $(event.target);
  // Set aria-expanded to true
  dropdown.find('.dropdown-menu').attr('aria-expanded', false);

  // Set focus on the first link in the dropdown
  if (dropdown[0].id === 'dd_search') {
    $('#searchFadeDiv').hide();
    disableBody(false);
  }
});

$('#searchFadeDiv').height($(window).height());

$(window).bind('resize', () => {
  $('#displaySearchResult').height($(window).height() - 100);
  $('#searchFadeDiv').height($(window).height());
});
